import { MenuItem } from '@mui/material';
import React from 'react';
import { PatchNotesEntry } from '../../../mesh/patchNotes';
import {
  cockpitMenuItemClassName,
  cockpitMenuItemSx,
} from './cockpitMenuStyles';
import { CockpitSelect } from './CockpitSelect';

type PatchNotesVersionSelectProps = {
  entries: PatchNotesEntry[];
  value: string;
  onVersionChange: (version: string) => void;
};

const selectSx = {
  width: 220,
  maxWidth: '100%'
};

const containerSx = {
  minWidth: 220,
  maxWidth: '100%',
  mb: 2
};

export function PatchNotesVersionSelect({
  entries,
  value,
  onVersionChange
}: PatchNotesVersionSelectProps) {
  return (
    <CockpitSelect
      testId="patchnotes-version-select"
      label="Version"
      value={value}
      onChange={(event) => onVersionChange(event.target.value)}
      MenuProps={{
        PaperProps: { sx: { minWidth: 220, maxWidth: 'calc(100vw - 32px)' } }
      }}
      containerSx={containerSx}
      sx={selectSx}
    >
      {entries.map((entry) => (
        <MenuItem
          key={entry.version}
          value={entry.version}
          className={cockpitMenuItemClassName}
          sx={cockpitMenuItemSx}
        >
          {entry.title}
        </MenuItem>
      ))}
    </CockpitSelect>
  );
}
